/******************************************************************************
 *** BgtAtrzTitleDialog ** 총괄조합비 결재상신 * 결재제목 입력 모달
*******************************************************************************/
import TextBox from "@/js/common/ui/input/TextBox";
import Button from "@/js/common/ui/Button";
import Util from "@/js/common/Util";
import AppContext from "@/js/common/AppContext";

interface Props {
    atrzTtlCn: string;
    setAtrzTtlCn: Function;
    setAtrzTitleModalOpen: Function;
    doApproval: () => void; // 결재상신 처리
    atrzProcessing: boolean; // 결재상신 버튼 비활성화
    setAtrzProcessing: Function;
}

const BgtAtrzTitleDialog = ({ atrzTtlCn, setAtrzTtlCn, setAtrzTitleModalOpen, doApproval, atrzProcessing, setAtrzProcessing }: Props) => {
    function goApproval() {
        if (Util.isEmpty(atrzTtlCn)) {
            AppContext.openAlert({
                title: "결재상신 제목 확인",
                msg: "결재상신 제목을 입력하세요.",
                icon: "warning"
            });
            return;
        }
        setAtrzProcessing(true); // 결재버튼 비활성화
        // 결재 상신 처리
        doApproval();
    }
    return (
        <div className="w100p dpFlx jcC">
            <div className="w420 p10">
                <div className="dpFlx flxdCol mb15">
                    <div className="h30 dpFlx aiE pb5">
                        <span className="fm-b fs13 ls06 fc111111">결재 제목</span>
                    </div>
                    <TextBox value={atrzTtlCn}
                        width={420} height={36}
                        fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                        borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                        placeholder="결재 제목을 입력하세요"
                        style={{ backgroundColor: "#fff", padding: "0 12px" }}
                        onChangeFunc={(text: string) => setAtrzTtlCn(text)}
                    />
                </div>

                <div className="bdt1 bdcDDDDDD mt10 mb15" />

                <div className="dpFlx jcR gap10">
                    <Button buttonName="취소"
                        width={90} height={38}
                        fontFamily="fm-b" fontSize={15} letterSpacing={-1}
                        variant="styCancelBtn" borderRadius={6}
                        buttonClass="dpFlx aiC jcC"
                        onClickFunc={() => {
                            setAtrzTtlCn("");
                            setAtrzProcessing(false); // 결재버튼 활성화
                            setAtrzTitleModalOpen(false);
                        }}
                    />

                    <Button buttonName="결재 상신"
                        width={100} height={38}
                        fontFamily="fm-b" fontSize={15} letterSpacing={-1}
                        variant="styCompleteBtn" borderRadius={6}
                        buttonClass="dpFlx aiC jcC"
                        disabled={atrzProcessing}
                        onClickFunc={() => goApproval()}
                    />
                </div>
            </div>
        </div>
    )
};

export default BgtAtrzTitleDialog;
